var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { fetchData } from '../helper/helper';
import ButtonComponent from './ButtonComponent';
import '../styles/navBtn.scss';
import React from 'react';
import globalStore from '../store';
import customEventHandler from '../helper/customEvents';
import { trackEvent, AnalyticsCategory } from '../helper/analytics';
var NavBtn = function (props) {
    var _a = useState(undefined), btnData = _a[0], setBtnData = _a[1];
    var _b = useState(undefined), btnType = _b[0], setBtnType = _b[1];
    var _c = globalStore.useStoreState(function (state) { return state.playerStore; }), displayMode = _c.displayMode, totalPages = _c.totalPages, currentPage = _c.currentPage;
    var setPages = globalStore.useStoreActions(function (state) { return state.playerStore; }).setPages;
    useEffect(function () {
        var _btnData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var uiData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetchData('./assets/data/btnData.json')];
                    case 1:
                        uiData = _a.sent();
                        setBtnData(uiData.btnConfig);
                        setBtnType(props.type === 'header'
                            ? uiData.mainConfig.navigationBtn
                            : uiData.mainConfig.navigationFooterBtn);
                        return [2 /*return*/];
                }
            });
        }); };
        _btnData();
    }, [props.type]);
    var jumpToPage = function (item) {
        var targetPage = currentPage;
        var direction = '';
        if (item.includes('nextpg')) {
            targetPage = currentPage + 1;
            direction = 'next';
        }
        else if (item.includes('prevPg')) {
            targetPage = currentPage - 1;
            direction = 'prev';
        }
        else if (item.includes('jumptoFirst')) {
            targetPage = 1;
            direction = 'first';
        }
        else if (item.includes('jumptoLast')) {
            targetPage = totalPages;
            direction = 'last';
        }
        if (direction && targetPage !== currentPage) {
            setPages({ currentPage: targetPage, totalPages: totalPages });
            // Page turns within an open activity — the per-activity "interaction
            // information" signal alongside the open event + heartbeat time-on-page.
            // Direction is the label; value is left at the default 1 so this event
            // counts like every other (Total Event value = count). The destination
            // page itself is implicit in the direction (first=1, last=totalPages).
            trackEvent(AnalyticsCategory.content, 'navigate', direction);
        }
        customEventHandler.dispatchEvent('navBtnClicked', { id: item, type: 'header' });
    };
    return (btnData && (_jsxs("div", { className: "nav_holder ".concat(props.class), children: [btnType.leftBtns.map(function (item, i) {
                return (_jsxs(React.Fragment, { children: [_jsx(ButtonComponent, { imgSrc: btnData[item].imgSrc, defaultCSS: btnType['style'].defaultCSS, normalCSS: btnType['style'].normalCSS, ariaLabel: btnData[item].ariaLabel, title: btnData[item].title, showToolTip: true, isParentRelative: true, direction: displayMode === 'normal' ? 'bottom' : 'top', clickHandler: function () { return jumpToPage(item); }, disabled: currentPage === 1 }), i === 0 && _jsx("hr", {})] }, "btn_".concat(i)));
            }), _jsx("div", { className: "page_ind", role: "status", "aria-label": "Page navigation indicator", children: _jsxs("div", { "aria-live": "polite", children: [_jsx("span", { className: "currentPg", children: currentPage }), _jsx("span", { className: "slash", "aria-hidden": "true", children: "/" }), _jsx("span", { className: "totalPg", style: { paddingTop: '6px' }, children: totalPages })] }) }), btnType.rightbtns.map(function (item, i) {
                return (_jsxs(React.Fragment, { children: [_jsx(ButtonComponent, { imgSrc: btnData[item].imgSrc, defaultCSS: btnType['style'].defaultCSS, normalCSS: btnType['style'].normalCSS, ariaLabel: btnData[item].ariaLabel, title: btnData[item].title, showToolTip: true, isParentRelative: true, direction: displayMode === 'normal' ? 'bottom' : 'top', clickHandler: function () { return jumpToPage(item); }, disabled: currentPage === totalPages }), i === 0 && _jsx("hr", {})] }, "btn_".concat(i)));
            })] })));
};
export default NavBtn;
